var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeetingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3523 22.2105L32.1678 26.304C32.3391 26.3802 32.5267 26.4123 32.7136 26.3976C32.9004 26.3828 33.0807 26.3215 33.2378 26.2194C33.395 26.1173 33.5242 25.9775 33.6136 25.8127C33.703 25.648 33.7499 25.4635 33.7499 25.2761V11.7226C33.7499 11.5352 33.703 11.3507 33.6136 11.186C33.5242 11.0212 33.395 10.8814 33.2378 10.7793C33.0807 10.6772 32.9004 10.6159 32.7136 10.6012C32.5267 10.5864 32.3391 10.6185 32.1678 10.6947L26.3523 14.7883C26.2048 14.8921 26.0845 15.0298 26.0014 15.1899C25.9183 15.3499 25.8749 15.5276 25.8749 15.708V21.2908C25.8749 21.4711 25.9183 21.6488 26.0014 21.8088C26.0845 21.9689 26.2048 22.1066 26.3523 22.2105Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8437 27.4976H5.90619C4.93735 27.4948 4.00898 27.1087 3.3239 26.4236C2.63883 25.7385 2.25272 24.8102 2.24994 23.8413V13.1538C2.25272 12.185 2.63883 11.2566 3.3239 10.5715C4.00898 9.88645 4.93735 9.50034 5.90619 9.49756H18.8774C19.8373 9.50053 20.7569 9.88313 21.4357 10.5618C22.1144 11.2406 22.497 12.1602 22.4999 13.1201V23.8413C22.4972 24.8102 22.111 25.7385 21.426 26.4236C20.7409 27.1087 19.8125 27.4948 18.8437 27.4976Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingIcon);
export default __webpack_public_path__ + "static/media/meeting-icon.b5f57cc8c7fa856e0348914e419dceb5.svg";
export { ForwardRef as ReactComponent };